export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold font-heading">
                歪
              </span>
              <span className="text-lg font-bold font-heading text-background-50">
                歪歪漫画
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              歪歪漫画网致力于为广大漫画爱好者提供海量免费漫画在线观看与阅读服务，覆盖韩漫、日漫、国漫全类型，支持下拉式流畅阅读，每日更新不断，是追更补番的不二之选。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#hero" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">人气排行</a>
              <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">最近更新</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">漫画分类</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">韩漫热门</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">日漫经典</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">国漫崛起</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">漫画索引</a>
              <a href="#media" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">精彩专题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">合作伙伴</h4>
            <p className="text-sm text-background-500">暂无合作伙伴信息</p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 歪歪漫画网. 本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">歪歪漫画在线免费观看</span>
            <span className="text-xs text-background-500">歪歪漫画在线免费阅读</span>
          </div>
        </div>
      </div>
    </footer>
  );
}